// src/pages/UserDetailsPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSubmissions } from '../services/api.service';
import moment from 'moment';
import Loading from '../components/loading';
import { FaChevronLeft } from 'react-icons/fa';

const UserDetailsPage = () => {
    const { email } = useParams();
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSubmissions = async () => {
            setLoading(true);
            try {
                const all = await getSubmissions();
                const filtered = all.filter(s => s.customer?.email === email);
                setSubmissions(filtered);
            } catch (err) {
                console.error("Erreur lors du chargement des soumissions", err);
            } finally {
                setLoading(false);
            }
        };

        fetchSubmissions();
    }, [email]);

    const STATUS_META = {
        'paid': { label: 'Payée', badge: 'bg-green-100 text-green-800', icon: '🆕' },
        'in-progress': { label: 'En cours', badge: 'bg-yellow-100 text-yellow-800', icon: '⏳' },
        'completed': { label: 'Complété', badge: 'bg-blue-100 text-blue-800', icon: '✅' },
        'rejected': { label: 'Rejeté', badge: 'bg-red-100 text-red-800', icon: '✖️' },
    };

    const renderStatusBadge = (status) => {
        const meta = STATUS_META[status] || { label: status || '—', badge: 'bg-gray-100 text-gray-700', icon: 'ℹ️' };
        return (
            <span className={`inline-flex items-center gap-1 rounded-full px-4 py-1 text-sm font-medium ${meta.badge}`}>
                <span aria-hidden>{meta.icon}</span>{meta.label}
            </span>
        );
    };

    return (
        <div className="max-w-5xl mx-auto p-6">
            <button
                onClick={() => navigate('/users')}
                className="text-gray-600 hover:text-gray-900 flex gap-2 items-centerflex flex-row items-center gap-2 hover:underline transition duration-150"
            >
                <FaChevronLeft /> Retour
            </button>

            <h1 className="text-2xl font-bold my-4">Soumissions de : {email}</h1>
            {loading ? (
                <Loading />

            ) : submissions.length === 0 ? (
                <p className="text-center py-12 text-gray-500">Aucune soumission trouvée pour cet utilisateur.</p>
            ) : (
                <div className="space-y-6">
                    {submissions.map((sub) => (
                        <div key={sub._id} className="border rounded p-4 bg-white shadow-sm">
                            <h2 className="font-semibold text-lg mb-2">
                                Dossier n° {sub.transactionNumber} — {moment(sub.createdAt).format('DD/MM/YYYY')}
                            </h2>
                            <p><strong>Nom :</strong> {sub.customer.lastname} {sub.customer.firstname}</p>
                            <p><strong>Email :</strong> {sub.customer.email}</p>
                            <p><strong>Sous-domaine :</strong> {sub.subdomain || '-'}</p>
                            <p><strong>Statut :</strong> {renderStatusBadge(sub.status)}</p>
                            <div className="mt-2">
                                <p className="font-semibold">Prestations :</p>
                                <ul className="list-disc list-inside">
                                    {sub.services.map(s => (
                                        <li key={s._id}>{s.title.fr} — {s.price.toFixed(2)}€</li>
                                    ))}
                                </ul>
                            </div>
                            <button
                                onClick={() => navigate(`/${sub._id}`)}
                                className="mt-4 inline-block px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
                            >
                                Voir le dossier
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UserDetailsPage;